<div class="header_hero-bg"></div>
<div class="mega-trade-container container-fluid">
  <div class="mega_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 pl-0">
          <div class="mega_header-information__sub-header" id="confirmation-label">
            Confirmation
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 pr-0">
          <button
            class="button fm-secondary-button float-end"
            (click)="downloadCollateralAnalyzerPDF()"
            id="download-pdf-button"
            [disabled]="downloadPDFButtonClicked"
          >
            <i class="fa fa-file-pdf-o button-icon"></i>EXPORT PDF
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-7 col-lg-7 pl-0 text-size" id="confirmation-info-text">
          The pool below has been created and the corresponding collateral has been submitted for
          allocation. You should receive confirmation emails for both the pool creation and
          collateral allocation at the contact email provided. If you do not, please contact
          <a
            href="mailto:structured_transactions@fanniemae.com"
            class="confirmation-page-anchor-link"
            >structured_transactions&#64;fanniemae.com</a
          >
          for assistance.
        </div>
        <div class="col-12 col-sm-12 col-md-5 col-lg-5 pr-0 dealer-details">
          <div class="float-end">
            <p id="dealer-text">
              <span class="fw-bold">Dealer: </span> {{ commitResponse.dealerName }}
            </p>
            <p id="dealer-contact">
              <span class="fw-bold">Dealer Contact: </span>{{ commitResponse.traderName }}
            </p>
            <p id="dealer-email">
              <span class="fw-bold">Contact Email: </span
              >{{ commitResponse?.traderEmail ? commitResponse?.traderEmail : '' }}
            </p>
            <p id="dealer-committed-date">
              <span class="fw-bold">Committed Date: </span>
              {{ commitResponse.committedDate | date: 'MM/dd/yyyy' }}
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container pl-0 pr-0">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl-0">
          <div id="pool-type-label" class="text-size">Pool Type</div>
        </div>
        <div class="col-12 col-sm-12 col-md-9 col-lg-9 pr-0">
          <a
            class="confirmation-page-anchor-link float-end"
            id="confirmation-page-anchor-link"
            (click)="downloadAnalyzerExcelConfirmationDetails()"
            >Download collateral list (xls)</a
          >
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl-0">
          <div class="fw-bold-and-size" id="pool-type-value">
            <ng-container *ngIf="commitResponse.megaType === 'SFFIXMEGA'">
              <div class="fw-bold-and-size">Single Family Fixed Rate</div>
            </ng-container>
            <ng-container *ngIf="commitResponse.megaType === 'SFARMMEGA'">
              <div class="fw-bold-and-size">Single Family ARM</div>
            </ng-container>
            <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
              <div class="fw-bold-and-size">Multi Family Fixed Rate</div>
            </ng-container>
            <ng-container *ngIf="commitResponse.megaType === 'MFARMMEGA'">
              <div class="fw-bold-and-size">Multi Family ARM</div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-10 pl-0 pr-0">
          <div class="fm-cdx-table">
            <table class="fm-cdx-table__static">
              <thead id="commit-page-single-pool-head">
                <tr class="th_row">
                  <th class="th_column">POOL #</th>
                  <th class="th_column width-25">CUSIP</th>
                  <th class="th_column width-25">PREFIX</th>
                  <ng-container *ngIf="commitResponse.megaType === 'SFFIXMEGA'">
                    <th class="th_column th_column--is-numeric">COUPON</th>
                  </ng-container>
                  <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
                    <th class="th_column th_column--is-numeric">HIGH COUPON</th>
                  </ng-container>
                  <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
                    <th class="th_column th_column--is-numeric">LOW COUPON</th>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      commitResponse.megaType === 'SFARMMEGA' ||
                      commitResponse.megaType === 'MFARMMEGA'
                    "
                  >
                    <th class="th_column">SUBTYPE</th>
                  </ng-container>
                  <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                  <th class="th_column pl-85">SETTLEMENT</th>
                  <th class="th_column th_column--is-numeric">FEE</th>
                </tr>
              </thead>
              <tbody id="commit-page-single-pool-body">
                <tr class="td_row commit-mega-table-header">
                  <td class="td_cell">
                    <span id="megaNumber" class="commit-to-recive-color">{{
                      commitResponse.poolNumber
                    }}</span>
                  </td>
                  <td class="td_cell">
                    <span id="cusip" class="commit-to-recive-color">{{
                      commitResponse.cusip
                    }}</span>
                  </td>
                  <td class="td_cell">
                    <span id="prefix">{{
                      commitResponse?.prefixCode ? commitResponse?.prefixCode : ''
                    }}</span>
                  </td>
                  <ng-container *ngIf="commitResponse.megaType === 'SFFIXMEGA'">
                    <td class="td_cell td_cell--is-numeric">
                      <span id="sfFixedCoupon">{{
                        commitResponse?.sfFixedCoupon | number: '1.3-3'
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
                    <td class="td_cell td_cell--is-numeric">
                      <span id="mfHighCoupon">{{
                        commitResponse?.mfHighCoupon | number: '1.3-3'
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
                    <td class="td_cell td_cell--is-numeric">
                      <span id="mfLowCoupon">{{
                        commitResponse?.mfLowCoupon | number: '1.3-3'
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      commitResponse.megaType === 'SFARMMEGA' ||
                      commitResponse.megaType === 'MFARMMEGA'
                    "
                  >
                    <td class="td_cell">
                      <span id="sfARMSubType">{{ commitResponse?.sfARMSubType }}</span>
                    </td>
                  </ng-container>
                  <td class="td_cell td_cell--is-numeric">
                    <span id="tradeAmount">{{
                      commitResponse?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                    }}</span>
                  </td>
                  <ng-container *ngIf="!showEarlyCloseLegend">
                    <td class="td_cell">
                      <span id="tradeSettlementDate">{{
                        commitResponse?.tradeSettlementDate | date: 'MM/dd/yyyy'
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="showEarlyCloseLegend">
                    <td class="td_cell">
                      <span id="tradeSettlementDate-earlyClose"
                        >{{ commitResponse?.tradeSettlementDate | date: 'MM/dd/yyyy'
                        }}<i class="fa fa-asterisk legend-icon pl-3"></i
                      ></span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="commitResponse?.feeDollars !== null">
                    <td class="td_cell td_cell--is-numeric">
                      <ng-container
                        *ngIf="needsDisclaimer(commitResponse?.prefixCode); else noDisclaimer"
                      >
                        <span id="newFeeDollars" class="fw-bold fee-warning-red">
                          {{ updateDisclaimerMessage() }}
                          {{ commitResponse?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                        </span>
                      </ng-container>
                      <ng-template #noDisclaimer>
                        <span id="newFeeDollars" class="fw-bold"
                          >{{ commitResponse?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                        </span>
                      </ng-template>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="commitResponse?.feeTicks !== null">
                    <td class="td_cell td_cell--is-numeric">
                      <ng-container
                        *ngIf="needsDisclaimer(commitResponse?.prefixCode); else noTickDisclaimer"
                      >
                        {{ updateDisclaimerMessage() }}
                        <span id="newFeeTicks" class="fw-bold fee-warning-red"
                          >{{ commitResponse?.feeTicks | number: '1.3-3' }}/32*
                        </span>
                      </ng-container>
                      <ng-template #noTickDisclaimer>
                        <span id="newFeeTicks" class="fw-bold"
                          >{{ commitResponse?.feeTicks | number: '1.3-3' }}/32
                        </span>
                      </ng-template>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <p class="fee-warning-red">{{ disclaimerMessage }}</p>

      <div class="row">
        <div class="col-12 col-md-5 pl-0 fw-bold text-size mt-25">
          <div>
            Pricing Summary -
            <span class="mega-pricing-pricing-month" *ngIf="!isMayPricingMonth"
              >{{ pricingSummary?.pricingMonth | date: 'MMM' }}.
              {{ pricingSummary?.pricingMonth | date: 'yyyy' }}</span
            >
            <span class="mega-pricing-pricing-month" *ngIf="isMayPricingMonth"
              >{{ pricingSummary?.pricingMonth | date: 'MMM' }}
              {{ pricingSummary?.pricingMonth | date: 'yyyy' }}</span
            >
          </div>
        </div>
        <div class="col-12 col-md-7 visible-md-7 pr-0 fw-bold mt-25">
          <div class="row">
            <div class="col-12 col-md-8">
              <span class="float-end" id="total-monthly-label"
                >Total Volume :
                <span id="total-monthly-volume">{{
                  totalMonthlyVolume | currency: 'USD' : 'symbol' : '1.0'
                }}</span></span
              >
            </div>
            <div class="col-12 col-md-4 pr-0">
              <span class="float-end">
                <span class="total-mega-pricing-count" id="total-pools"
                  >Total Pools: {{ pricingSummaryList.length }}</span
                >
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12 pl-0 fw-bold">
          <div class="col-12 col-sm-12 col-md-8 col-lg-8 pl-0">
            <span class="">Total Volume: <span>{{ totalMonthlyVolume | currency:'USD':'symbol':'1.0' }}</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 pr-0 pl-0">
            <span class=" total-mega-pricing-count">Total Pools: {{ pricingSummaryList.length}}</span>
          </div>
        </div> -->
      </div>

      <div class="row" *ngIf="pricingSummaryList.length > 0">
        <div class="col-12 mega-pricing-update-table mt-10 px-0">
          <div class="fm-cdx-table">
            <table class="fm-cdx-table__static">
              <thead id="pricing-summary-table-head">
                <tr class="th_row">
                  <th class="th_column">POOL #</th>
                  <th class="th_column width-25">CUSIP</th>
                  <th class="th_column width-25">PREFIX</th>
                  <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                  <th class="th_column pl-85">SETTLEMENT</th>
                  <th class="th_column th_column--is-numeric">FEE</th>
                </tr>
              </thead>
              <tbody id="pricing-summary-table-body">
                <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
                  <tr
                    class="td_row commit-mega-table-header"
                    *ngFor="let megaPricing of pricingSummaryList; trackBy: trackByIdentity"
                  >
                    <td class="td_cell width-poolNumber-MFFIX">
                      <span id="pricing-update-mf-mega-number">{{ megaPricing?.poolNumber }}</span>
                    </td>
                    <td class="td_cell width-cusip-MFFIX">
                      <span id="pricing-update-mf-cusip">{{ megaPricing?.cusip }}</span>
                    </td>
                    <td class="td_cell width-prefix-MFFIX">
                      <span id="pricing-update-mf-prefixCode">{{ megaPricing?.prefixCode }}</span>
                    </td>
                    <td class="td_cell td_cell--is-numeric width-tradeAmount-MFFIX">
                      <span id="pricing-update-mf-trade-amount">{{
                        megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                      }}</span>
                    </td>
                    <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85 width-settelmentDate-MFFIX">
                        <span id="pricing-update-settlementDate-MFFIX">{{
                          megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                        }}</span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85 width-settelmentDate-MFFIX">
                        <span id="pricing-update-settlementDate-earlyClose-MFFIX"
                          >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                          }}<i class="fa fa-asterisk legend-icon pl-3"></i
                        ></span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.feeDollars !== null">
                      <td class="td_cell td_cell--is-numeric">
                        <span id="pricingFee-mf-feeDollars" class="fw-bold"
                          >{{ megaPricing?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.feeTicks !== null">
                      <td class="td_cell td_cell--is-numeric">
                        <span id="pricingFee-mf-feeTicks" class="fw-bold"
                          >{{ megaPricing?.feeTicks | number: '1.3-3' }}/32
                        </span>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
                <ng-container *ngIf="commitResponse.megaType !== 'MFFIXMEGA'">
                  <tr
                    class="td_row commit-mega-table-header"
                    *ngFor="let megaPricing of pricingSummaryList; trackBy: trackByIdentity"
                  >
                    <td class="td_cell width-poolNumber">
                      <span id="pricing-update-mega-number">{{ megaPricing?.poolNumber }}</span>
                    </td>
                    <td class="td_cell width-cusip">
                      <span id="pricing-update-cusip">{{ megaPricing?.cusip }}</span>
                    </td>
                    <td class="td_cell width-prefixCode">
                      <span id="pricing-update-prefixCode">{{ megaPricing?.prefixCode }}</span>
                    </td>
                    <td class="td_cell td_cell--is-numeric width-tradeAmount">
                      <span id="pricing-update-trade-amount">{{
                        megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                      }}</span>
                    </td>
                    <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85 width-settelmentDate">
                        <span id="pricing-update-settlementDate">{{
                          megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                        }}</span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85 width-settelmentDate">
                        <span id="pricing-update-settlementDate-earlyClose"
                          >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                          }}<i class="fa fa-asterisk legend-icon pl-3"></i
                        ></span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.feeDollars !== null">
                      <td class="td_cell td_cell--is-numeric">
                        <ng-container
                          *ngIf="needsListDisclaimer(megaPricing); else noListDisclaimer"
                        >
                          <span id="pricingFee-feeDollars" class="fw-bold fee-warning-red">
                            {{ updateListDisclaimerMessage() }}
                            {{ megaPricing?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                          </span>
                        </ng-container>
                        <ng-template #noListDisclaimer>
                          <span id="pricingFee-feeDollars" class="fw-bold"
                            >{{ megaPricing?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                          </span>
                        </ng-template>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.feeTicks !== null">
                      <td class="td_cell td_cell--is-numeric">
                        <ng-container
                          *ngIf="needsListDisclaimer(megaPricing); else noTickListDisclaimer"
                        >
                          {{ updateListDisclaimerMessage() }}
                          <span id="pricingFee-feeTicks" class="fw-bold fee-warning-red"
                            >{{ megaPricing?.feeTicks | number: '1.3-3' }}/32*
                          </span>
                        </ng-container>
                        <ng-template #noTickListDisclaimer>
                          <span id="pricingFee-feeTicks" class="fw-bold"
                            >{{ megaPricing?.feeTicks | number: '1.3-3' }}/32
                          </span>
                        </ng-template>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <p class="fee-warning-red">{{ listDisclaimerMessage }}</p>
        </div>
      </div>
      <div class="row" *ngIf="showEarlyCloseLegendPricingSummary">
        <div class="col-12 mt-25">
          <p>
            <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be
            sure someone from the Structured Transactions team is available to complete this
            transaction.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
